import { Breadcrumb } from 'components/Breadcrumb';
import { useState, useEffect } from 'react';
import { CgArrowRight } from 'react-icons/cg';
import { MdCheck, MdError } from 'react-icons/md';
import { BiDownload } from 'react-icons/bi';
import { useParams } from 'react-router-dom';
import { useHistoryWithHost } from 'routes/useHistoryWithHost';
import {
  Modal,
  Button,
  ModalCloseButton,
  ModalContent,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
  Flex,
} from '@grupoboticario/flora-react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getClaimByIdAction,
  getStatusActionsAction,
  getStepsByIdAction,
} from 'store/modules/claims/actions';
import { ApplicationState } from 'store/store.inteface';
import { FilesCallback } from 'components/UploadDocument';
import { sendFile } from 'utils/sendFile';
import { BROKER_ACTIONS } from 'utils/statusEnum';
import { downloadFile } from 'utils/downloadFile';
import CardDocument from './CardDocument/CardDocument';
import { NoContent } from './NoContent/NoContent';
import {
  Container,
  Content,
  Main,
  Title,
  CardDocumentContainer,
  Label,
  ModalText,
  ButtonWrapper,
  ModalIcon,
  SidebarWrapper,
  Sidebar,
} from './styles';
import { Loading } from './Loading';

export function DocumentRequest() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistoryWithHost();

  const { statusActions } = useSelector(
    (state: ApplicationState) => state.claims,
  );
  const { claimById } = useSelector((state: ApplicationState) => state.claims);

  const { stores, cpId } = useSelector(
    (state: ApplicationState) => state.storesContext,
  );
  const stepClaimStatus = useSelector(
    (state: ApplicationState) => state.claims.stepsClaimStatus,
  );
  const [files, setFiles] = useState<FilesCallback[]>([]);
  const [modalSair, setModalSair] = useState(false);
  const [modalEnviar, setModalEnviar] = useState(false);
  const [modalError, setModalError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isPartial, setIsPartial] = useState(false);
  const [loadingData, setLoadingData] = useState(false);

  useEffect(() => {
    const partialPaid = stepClaimStatus.find(
      obj => obj.statusBroker === BROKER_ACTIONS.PaidProcessPP,
    );

    if (partialPaid) {
      setIsPartial(true);
    } else {
      setIsPartial(false);
    }
  }, [isPartial, stepClaimStatus]);

  const sendFiles = async () => {
    setLoading(true);
    try {
      await sendFile(
        id,
        files,
        isPartial ? 'documentRequestPP' : 'documentRequest',
        cpId,
        claimById.franchise.code,
      );
      setModalEnviar(true);
    } catch {
      setModalError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (stores.length > 0) {
      dispatch(getClaimByIdAction(id));
      dispatch(getStatusActionsAction(id));
      dispatch(getStepsByIdAction(id));
    }
  }, [dispatch, id, stores]);

  const filesDelete = (file: any) => {
    const newFiles = files.filter((o: any) => o.file.data !== file.data);
    setFiles(newFiles);
  };

  const filesUpload = (newFiles: any) => {
    const uniqueNewFiles = newFiles.filter(
      (file: any) => !files.some((f: any) => f.file.data === file.file.data),
    );
    setFiles([...files, ...uniqueNewFiles]);
  };

  function removeExtension(fileName) {
    const filename = fileName.split('.');
    return filename.slice(0, -1).join('.');
  }

  useEffect(() => {
    setLoadingData(false);
    if (!statusActions.documentAction) {
      setLoadingData(true);
    }
  }, [statusActions]);

  return (
    <Container>
      <Breadcrumb color="light" claimNumber={statusActions.number} />
      <Flex>
        <Content>
          <Title>Tutorial</Title>
          <Label>Baixe aqui o material de apoio</Label>
          {statusActions.hasFilesTutorial ? (
            <SidebarWrapper>
              <Sidebar>
                <ul>
                  {statusActions.filesTutorial?.map(item => {
                    const filename = removeExtension(item.filename);
                    return (
                      <li key={item.filename}>
                        <div>{filename}</div>
                        <Button
                          aria-label=""
                          onClick={() =>
                            downloadFile(item.url, `${item.filename}`)
                          }
                          hierarchy="tertiary"
                          has="iconOnly"
                          icon={<BiDownload />}
                        />
                      </li>
                    );
                  })}
                </ul>
              </Sidebar>
            </SidebarWrapper>
          ) : (
            <NoContent />
          )}
        </Content>
        <Main>
          <Title>
            <span>Documentação</span>
          </Title>
          <Label>
            Para dar continuidade neste processo, será necessário seguir com as
            solicitações abaixo indicadas.
          </Label>
          {loadingData ? (
            <Loading />
          ) : (
            <>
              <CardDocumentContainer>
                {statusActions.documentAction?.map((doc: any) => {
                  return (
                    <CardDocument
                      key={doc}
                      idDoc={doc}
                      title={doc}
                      required
                      hasLoadingFiles={false}
                      callbackFunc={filesUpload}
                      deleteFile={filesDelete}
                    />
                  );
                })}
              </CardDocumentContainer>
              <ButtonWrapper>
                <Button
                  className="sair"
                  size="small"
                  onClick={() => setModalSair(true)}
                >
                  Sair
                </Button>
                <Button
                  className="enviar"
                  size="small"
                  styleSemantic="success"
                  onClick={sendFiles}
                  disabled={!files.length || loading}
                >
                  Enviar
                  <CgArrowRight size={17} className="" />
                </Button>
              </ButtonWrapper>
            </>
          )}
          <Modal open={modalSair} onOpenChange={setModalSair}>
            <ModalContent size="small">
              <ModalCloseButton />
              <ModalHeader />
              <ModalBody>
                <ModalText>Deseja mesmo sair?</ModalText>
              </ModalBody>
              <ModalFooter>
                <Button onClick={() => history.goBack()}>Sim</Button>
                <Button
                  styleSemantic="warning"
                  onClick={() => setModalSair(false)}
                >
                  Não
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>

          <Modal open={modalEnviar} onOpenChange={() => history.goBack()}>
            <ModalContent size="small">
              <ModalCloseButton />
              <ModalHeader />
              <ModalBody>
                <ModalText>
                  <MdCheck color="green" />
                  <p>
                    Documento(s) reenviado(s)
                    <br />
                    com sucesso!
                  </p>
                  <span>Seu código: {statusActions.number} </span>
                  <p>
                    Seus dados e documentos foram enviados para análise.
                    <br />
                    Você receberá avisos no status deste processo, fique de
                    olho!
                  </p>
                </ModalText>
              </ModalBody>
              <ModalFooter>
                <Button
                  styleSemantic="success"
                  onClick={() => history.goBack()}
                >
                  OK
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>

          <Modal open={loading}>
            <ModalContent size="small">
              <ModalHeader />
              <ModalBody>
                <ModalText>
                  <ModalIcon>
                    <Spinner size="sm" />
                  </ModalIcon>
                  <span>Aguarde um momento!</span>
                  <p>Enviando documentos.</p>
                </ModalText>
              </ModalBody>
              <ModalFooter />
            </ModalContent>
          </Modal>

          <Modal open={modalError} onOpenChange={() => setModalError(false)}>
            <ModalContent size="small">
              <ModalCloseButton />
              <ModalHeader />
              <ModalBody>
                <ModalText>
                  <MdError color="red" />
                  <span>Error ao enviar documentos!</span>
                  <p>Tente novamente.</p>
                </ModalText>
              </ModalBody>
              <ModalFooter>
                <Button
                  styleSemantic="success"
                  onClick={() => setModalError(false)}
                >
                  OK
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </Main>
      </Flex>
    </Container>
  );
}
